export interface InputModel {
  label?: string;
  value?: string;
  widthSize?: WidthSizes;
  placeholder?: string;
}


export enum WidthSizes {
  widthSmall = 'width-small',
  widthDefault = 'width-default',
  widthExtraSmall = 'width-extra-small', // For compact layouts (e.g., side-by-side inputs)
  widthFull = 'width-full', // Full width for single column layouts
}
